import { EllipsisVIcon, FileIcon, GreyIconWrapper, SingleInfoCard, Typography } from '@forgeglobal/design-framework'
import { FileFragment } from 'graphql/bindings/AdminBindings'
import { PopoverAction } from 'isolated-design-library'
import React, { Fragment } from 'react'
import moment from 'moment'

import { tagMap } from './Documents'
import DocumentActions from './DocumentActions'

export interface AccountFile {
  file: FileFragment
  account?: {
    id: string
    name: string
  }
}

interface DocumentListProps {
  files: AccountFile[]
  accountId: string
  type: 'primary' | 'related'
}

const DocumentList: React.FC<DocumentListProps> = ({ accountId, files, type }) => {
  return (
    <Fragment>
      {files.map((accountFile: AccountFile) => {
        const { file, account } = accountFile
        const { filename, date_created } = file
        const notes = `Uploaded ${moment(date_created).format('MM/DD/YYYY')} | ${tagMap[file.tags[0]?.tag] ??
          'Document tag not found'}`
        return (
          <SingleInfoCard
            openInNewTab
            key={date_created.toString() + filename}
            logo={
              <GreyIconWrapper>
                <FileIcon />
              </GreyIconWrapper>
            }
            leftTitle={filename ?? 'Name not found'}
            leftSubtitle={notes}
            notes={
              type === 'related' && (
                <Typography variant="body2" color="textSecondary" display="block">
                  {`Linked from ${account?.name}`}
                </Typography>
              )
            }
            action={
              <PopoverAction
                icon={<EllipsisVIcon />}
                actionMenu={<DocumentActions file={file} accountId={accountId} type={type} />}
              />
            }
          />
        )
      })}
    </Fragment>
  )
}

export default DocumentList
